/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { getFile, getVideoForIDB } from '@/store/files/actions';
import { getVideo, setVideoBlockFinish, setVideoBlockStart } from '@/store/lms/actions';

import { selectFiles } from '@/store/files/selectors';
import { selectLMS, selectVideo } from '@/store/lms/selectors';

import { Button, notification, Spin } from 'antd';
import ArticleFrame from '@/components/ArticleFrame';
import Condition from '@/components/Condition';
import { DeleteOutlined, DownloadOutlined } from '@ant-design/icons';

import { MediaPlayerComp } from './MediaPlayer';

import Utils from '@/Utils';
import { openDB } from 'idb';

import css from './index.module.scss';

import { IDB_NAME, VIDEO_IDB } from '@/constants/IndexedDB';
import { FINISHED } from '@/constants/study-plan-statuses';

export const Video = props => {
  const { block, getStatistic, updateChaptersIDB, removeChaptersFromIDB } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation('video');

  const videoData = useSelector(selectVideo);
  const videoFile = useSelector(selectFiles);
  const { statistic } = useSelector(selectLMS);

  const playerRef = useRef(null);

  const [image, setImage] = useState(null);
  const [isVideoIDB, setIsVideoIDB] = useState(false);
  const [isFinishButtonActive, toggleIsFinishButtonActive] = useState(false);
  const [videoIDB, setVideoIDB] = useState(null); // для проверки чтения из локальной бд плеером видео

  const next = statistic?.blocksStat && statistic.blocksStat.filter(item => item.status !== FINISHED).length;

  const isOnline = () => Utils.isOnline();

  useEffect(() => {
    checkVideoIDB();
    if (block.coverImage && isOnline()) {
      dispatch(
        getFile(block.coverImage, blob => {
          setImage(URL.createObjectURL(blob));
        })
      );
    }
    if (!block.isAvailableForStart && isOnline()) {
      dispatch(
        getVideo(block.video.id, () => {
          playerRef && playerRef.current?.load();
        })
      );
    }

    if (block.isAvailableForStart) {
      dispatch(setVideoBlockStart(block.blockId, () => getStatistic(true)));
    }
    !isOnline() && getVideoIDB();
  }, [block.video.id, playerRef]);

  useEffect(() => {
    if (videoFile.videoIDB !== null) {
      addIDBVideo();
    }
  }, [videoFile.videoIDB]);

  const finishVideoBlock = () => {
    dispatch(setVideoBlockFinish(block.blockId, () => getStatistic(next <= 1)));
  };

  const checkVideoIDB = async () => {
    const db = await openDB(IDB_NAME);
    const video = await db.get(VIDEO_IDB, block.video.id);
    if (video) {
      setIsVideoIDB(true);
    } else {
      setIsVideoIDB(false);
    }
  };

  const getVideoIDB = async () => {
    const db = await openDB(IDB_NAME);
    if (db.objectStoreNames.contains(VIDEO_IDB)) {
      const videoFromIDB = await db.get(VIDEO_IDB, block.video.id);
      if (videoFromIDB) {
        setIsVideoIDB(true);
        setVideoIDB(window.URL.createObjectURL(videoFromIDB.value));
      } else {
        setIsVideoIDB(false);
      }
    }
  };

  const transactionVideoIDB = async () => {
    const db = await openDB(IDB_NAME);
    if (!isVideoIDB && videoData.video && videoData.video.url) {
      dispatch(getVideoForIDB(videoData.video.url));
    }

    if (isVideoIDB) {
      await db.delete(VIDEO_IDB, block.video.id);
      removeChaptersFromIDB();
      setIsVideoIDB(false);
    }
  };

  const addIDBVideo = async () => {
    const db = await openDB(IDB_NAME);

    if (navigator.storage && navigator.storage.estimate) {
      const quota = await navigator.storage.estimate();
      const remaining = quota.quota - quota.usage;

      if (videoFile.videoIDB && videoFile.videoIDB.size > remaining) {
        notification['error']({
          message: t('error'),
          description: t('textError'),
          placement: 'radius-bottomright',
        });
        return;
      }
    }
    if (!isVideoIDB) {
      await db.add(VIDEO_IDB, {
        value: videoFile.videoIDB,
        id: block.video.id,
      });
      setIsVideoIDB(true);
      updateChaptersIDB();
    }
  };

  return (
    <div className={css.VideoWrapper}>
      {videoData.isLoading && !videoIDB ? (
        <Spin className={css.SpinVideo} />
      ) : (
        <Condition when={(block && videoData.video) || videoIDB}>
          <div className={css.VideoHeader}>
            <div>
              <div className={css.VideoTypeTitle}>
                {t('video')}
                {videoFile.isLoading && !videoIDB ? (
                  <Spin />
                ) : (
                  <Button
                    onClick={transactionVideoIDB}
                    type={isVideoIDB ? 'danger' : 'primary'}
                    icon={isVideoIDB ? <DeleteOutlined /> : <DownloadOutlined />}
                    shape='circle'
                  ></Button>
                )}
              </div>
              <div className={css.VideoTitle} data-qa='videoTitle'>
                {block.name}
              </div>
            </div>
          </div>

          <div className={css.VideoComment}>
            {block?.commentBlock && (
              <ArticleFrame
                title='Article'
                body={block?.commentBlock} // TODO: remove when that fixed
              />
            )}
          </div>

          <div
            className={css.VideoPlayer}
            onContextMenu={e => e.preventDefault()}
            onClick={() => toggleIsFinishButtonActive(true)}
            onTouchStart={() => toggleIsFinishButtonActive(true)}
          >
            <MediaPlayerComp
              block={block}
              image={image}
              isFinishButtonActive={isFinishButtonActive}
              videoIDB={videoIDB}
              finishVideoBlock={finishVideoBlock}
              next={next}
              playerRef={playerRef}
            />

            {/* Кнопка Далее */}
            <div className={css.VideoButtons}>
              {block.status !== 'FINISHED' && isOnline() && (
                <Button
                  data-qa='videoButton'
                  onClick={finishVideoBlock}
                  type='primary'
                  size='large'
                  disabled={!isFinishButtonActive}
                >
                  {next > 1 ? t('next') : t('end')}
                </Button>
              )}
            </div>
          </div>
        </Condition>
      )}
    </div>
  );
};
